import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6b7dfb66"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b7dfb66')) {
      api.createRecord('6b7dfb66', component.options)
    } else {
      api.reload('6b7dfb66', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6b7dfb66", function () {
      api.rerender('6b7dfb66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/trailer/index.vue"
export default component.exports